import React, { memo } from 'react';
import { useDispatch } from 'react-redux';

import DefaultButton from 'components/atoms/DefaultButton';
import { useMyUserHasInternalPermission } from 'store/modules/myUser/hooks';
import { appendValuesToQueryString } from 'store/modules/routerUtils/actions';
import { ProtectedResource, ResourceAction } from 'types/action.enum';

function BackOfficeEnterpriseCreateButton(): JSX.Element | null {
  const hasPermission = useMyUserHasInternalPermission({
    resource: ProtectedResource.ENTERPRISE,
    action: ResourceAction.ADD
  });

  const dispatch = useDispatch();

  if (!hasPermission) return null;

  const handleClick = () => {
    dispatch(
      appendValuesToQueryString({
        selectedEnterprise: undefined,
        drawer: 'addEnterprise'
      })
    );
  };

  return (
    <DefaultButton
      id="add-enterprise-button"
      type="primary"
      size="small"
      onClick={handleClick}
      mobileChildren="ADD"
    >
      ADD ENTERPRISE
    </DefaultButton>
  );
}

export default memo(BackOfficeEnterpriseCreateButton);
